import { MVKPhase } from '../../types/mvk_state';
import { triggerBodyClass } from '../dom/bodyClass';
import { getURIWithoutHash } from '../parsers/url';
import { updateRouteState } from '../routerHelper';
export var MVK_QUERY_STRING_PARAMS = ['gk_mvk_map_popup', 'gk_mvk_section_popup', 'gk_mvk_flat_popup', 'gk_mvk_flat_plan_floor', 'gk_mvk_flat_plan_types', 'gk_mvk_flat_card'];
export var ACTIONS_THAT_UPDATE_ROUTE = ['ISetMVKPhaseAction', 'ISetFlatIdAction', 'IToggleFlatFilterAction', 'ISetFloorFilterAction', 'IToggleFullScreenAction', 'IToggleRouteUpdateAction'];

// Экшены, которые в любом случае жестко обновлят window.history
export var WHITE_LIST_ROUTE_ACTIONS = ['IToggleFullScreenAction', 'ISetFlatIdAction'];
var updateQueryStringByState = function updateQueryStringByState(store, shouldReplaceState) {
  var state = store.MVKState;
  var queryString = document.location ? document.location.search : '';
  var pathname = document.location ? document.location.pathname : '';

  // Удаляем все МВКшные параметры из урла
  var newUrl = getUrlWithoutMvkParams(pathname + queryString);

  // Подготавливаем новые МВКшные параметры
  var mvkQueryStringParams = getMVKQueryStringParams(state);

  // Проставляем новый параметры в урл и пушим в хистори
  MVK_QUERY_STRING_PARAMS.forEach(function (key) {
    var value = mvkQueryStringParams[key];
    if (value === undefined || Array.isArray(value) && !value.length) {
      return;
    }
    var prefix = newUrl.includes('?') ? '&' : '?';
    newUrl += "".concat(prefix).concat(key, "=").concat(mvkQueryStringParams[key]);
  });
  var uri = window.history.state && getURIWithoutHash(window.history.state.uri || '');
  if (uri !== newUrl) {
    newUrl += '#map';
    if (shouldReplaceState) {
      window.history.replaceState({
        uri: newUrl,
        isInitState: false
      }, document.title, newUrl);
    } else {
      window.history.pushState({
        uri: newUrl,
        isInitState: false
      }, document.title, newUrl);
    }
  }
};
export var routerMiddleware = function routerMiddleware(store) {
  return function (next) {
    return function (action) {
      var prevMVKPhase = store.getState().MVKState.phase;
      var result = next(action);
      var newState = store.getState();
      var newMVKPhase = newState.MVKState.phase;
      var isRouteUpdate = action.type === 'IToggleRouteUpdateAction';
      var shouldUpdateQS = WHITE_LIST_ROUTE_ACTIONS.includes(action.type) || newMVKPhase !== prevMVKPhase || prevMVKPhase === MVKPhase.SECTION && !isSectionRouteBad(newState.MVKState);
      if (window && ACTIONS_THAT_UPDATE_ROUTE.includes(action.type) && shouldUpdateQS && !newState.MVKState.isOfferCard) {
        updateQueryStringByState(newState, isRouteUpdate);
        updateRouteState();
      }
      if (isRouteUpdate) {
        triggerBodyClass('mvk_full_screen', newState.MVKState.isFullScreen);

        // Если при смене роута открыт фулскрин фоторамы, то закрываем его
        setTimeout(function () {
          try {
            window.$('.fotorama--fullscreen').data('fotorama').cancelFullScreen();
            document.body.className = document.body.className.replace('mvk_fotorama_fullscreen', '');
          } catch (e) {
            // ignore error
          }
        }, 0);
      }
      return result;
    };
  };
};
function getUrlWithoutMvkParams(sourceURL) {
  var splittedSourceURL = sourceURL.split('?');
  var path = splittedSourceURL[0];
  var queryString = getURIWithoutHash(splittedSourceURL[1]);
  if (queryString) {
    var paramsArray = queryString.split('&');
    for (var i = paramsArray.length - 1; i >= 0; i -= 1) {
      var param = paramsArray[i].split('=')[0];
      if (MVK_QUERY_STRING_PARAMS.includes(param)) {
        paramsArray.splice(i, 1);
      }
    }
    if (paramsArray.length) {
      path += '?';
    }
    path = "".concat(path).concat(paramsArray.join('&'));
  }
  return path;
}
function getMVKQueryStringParams(state) {
  return {
    gk_mvk_flat_card: state.flat ? state.flat.id : undefined,
    gk_mvk_flat_plan_floor: state.section && state.section.id ? state.sectionPhaseFilters.selectedFloor : undefined,
    gk_mvk_flat_plan_types: state.section && state.section.id ? state.sectionPhaseFilters.selectedFlatTypes : undefined,
    gk_mvk_flat_popup: state.section ? state.section.id : undefined,
    gk_mvk_map_popup: state.isFullScreen ? 1 : undefined,
    gk_mvk_section_popup: state.house ? state.house.id : undefined
  };
}
function isSectionRouteBad(state) {
  return state.phase === MVKPhase.SECTION && state.sectionPhaseFilters.selectedFloor === undefined;
}